
<template>
  <div class='toastr-overlay'>
    <Toast
        v-for="toastr in toasts"
        :key="toastr.id"
        :id="toastr.id"
        :title="toastr.title"
        :message="toastr.message"
        :type="toastr.type"
        :timeout="toastr.options.timeout"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import Toast from './Toastr.vue';

export default {
  components: { Toast },
  computed: {
    ...mapState('toastr', ['items']),
    toasts() {
      console.log('toasts', this.items);
      return this.items;
    }
  },
};

console.log('ToastrContainer.vue');
</script>

<style scoped>
.toastr-overlay {
  position: fixed;
  z-index: 1000;
  top: 20px;
  right: 20px;
  margin-left: 20px;
  max-width: 420px;
  background-color: transparent;
}
@media screen and (max-width: 500px) {
  .toastr-overlay {
    top: 20px;
    right: 20px;
  }
}
</style>
